import { useMiniSite } from "../../components/minisite/context";
import { ReviewsSection } from "../RentalProfile";

export default function MiniSiteReviewsPage() {
  const { data, theme } = useMiniSite();
  const reviews = data.reviews || [];

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="ms-reviews-page">
      <h1 className="font-display text-3xl sm:text-4xl font-bold" style={{ color: theme }}>
        Reviews
      </h1>
      {data.rating_avg != null && (
        <div className="text-amber-700 font-semibold mt-1">
          {data.rating_avg.toFixed(1)} ★ · {data.rating_count} booking-linked review{data.rating_count === 1 ? "" : "s"}
        </div>
      )}
      {reviews.length === 0 ? (
        <p className="text-slate-500 italic mt-3" data-testid="ms-reviews-empty">
          No reviews yet. Be the first after your rental.
        </p>
      ) : (
        <div className="mt-4">
          <ReviewsSection reviews={reviews} avg={data.rating_avg} count={data.rating_count} />
        </div>
      )}
    </div>
  );
}
